module.exports = __webpack_public_path__ + "0f3099b7e4fd2796a074669767429ab7.pdf";